import { render } from "./replaceOrDeleteHubModal.vue?vue&type=template&id=83cb4428"
import script from "./replaceOrDeleteHubModal.vue?vue&type=script&lang=js"
export * from "./replaceOrDeleteHubModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__